import {
  customerMarketEventsApi,
  customerMarketShopfrontApi,
  Site
} from '@envato/foundation-types'
import get from 'lodash-es/get'
import axiosVerbose from './axios/axiosVerbose'

import { PageType } from '../../typings/routes'
import { config } from '../config'
import filterParamsConfig from '../constants/filterParamsConfig'
import { ILocationParams } from '../reducers/reactRouterLocation'
import { logError } from './errors'

const formatParams = (query: any) => {
  const formattedParams: any = {}

  const params = Object.keys(query).filter(
    param => ['term', 'site'].indexOf(param) === -1
  )

  params.forEach(param => {
    const paramConfig = filterParamsConfig[param]
    const isMultiple =
      param !== 'category' && paramConfig && paramConfig.isMultiple
    const value = isMultiple ? query[param].split(',') : query[param]

    if (value !== 0 && value) {
      formattedParams[param] = value
    }
  })
  return formattedParams
}

/**
 * Log success search result or timed out result to events api
 * @param {Object/null} results
 * @param {Object} query
 * @param {Object} user
 * @param {Boolean} timeout
 */
export const logSearchResult = ({
  results,
  locationParams,
  currentSite,
  pathname,
  pageType,
  user = null,
  timeout = false
}: {
  results: customerMarketShopfrontApi.search.IResult | undefined
  locationParams: ILocationParams
  currentSite: Site
  pathname: string
  pageType?: PageType
  user: any | null
  timeout: boolean
}) => {
  const query: any = {
    ...locationParams,
    site: `${currentSite}.net`
  }
  const data: customerMarketEventsApi.collect.IEventPayload = {
    event: 'item.keyword',
    search_phrase: query.term,
    timed_out: timeout,
    site: query.site,
    page_type: pageType,
    pathname,
    params: {
      view: 'list',
      page: 1
    }
  }

  if (results) {
    data.total_hits = results.total_hits
    data.params.item_ids =
      get(results, 'matches.length') && results.matches.map(item => item.id)
  }

  if (user) {
    data.params.view = get(user, 'preferences.searchResultsViewType') || 'list'
    if (user.profile) {
      data.username = user.profile.username
      data.user_id = user.profile.id
      data.envato_id = user.profile.envato_id
    }
  }

  data.params = {
    ...data.params,
    ...formatParams(query)
  }

  collect(data)
}

export const logPageview = ({
  currentSite,
  pathname,
  pageType,
  metrics,
  params
}: {
  currentSite: string
  pathname: string
  pageType?: PageType
  metrics: any
  params: any
}) => {
  const data: customerMarketEventsApi.collect.IEventPayload = {
    event: 'pageview',
    page_type: pageType,
    pathname,
    site: currentSite,
    performance_metrics: metrics,
    params: formatParams(params)
  }

  collect(data)
}

const collect = (data: customerMarketEventsApi.collect.IEventPayload) => {
  if ('sendBeacon' in navigator) {
    navigator.sendBeacon(
      `${config.eventsApi.URL}/collect`,
      JSON.stringify(data)
    )
  } else {
    axiosVerbose
      .post(`${config.eventsApi.URL}/collect`, data, { withCredentials: true })
      .catch(logError)
  }
}
